import template from './index.jst';
import { View } from "backbone.marionette";
import { Model } from 'backbone';

export default class CoachSubscriptionTypeView extends View {
	get template() {
		return template;
	}

	get className() {
		return 'form-group';
	}

	ui() {
		return {
			radio: '.js-subscription-type'
		}
	}

	events() {
		return {
			'change @ui.radio': 'updateModel'
		}
	}

	initialize() {
		this.model = new Model({
			assistant_coach_plan: 'season',
			title_part: 'Select',
		});
	}

	init({ selected_subscription_type, is_plan_payed }) {
		const title_part = is_plan_payed ? 'Your' : 'Select';

		this.model.set({
			assistant_coach_plan: selected_subscription_type,
			title_part
		});

		this.render();
	}

	updateModel(event) {
		const assistant_coach_plan = event.currentTarget.value;

		this.model.set({
			assistant_coach_plan
		}, { silent: true });

		this.trigger('plan:changed', assistant_coach_plan);
	}
}